<template>
  <div class="faq-unit">
    <div
      class="faq-unit__title"
      :class="{ 'faq-unit__title--open': !collapsed }"
      @click="toggleCollapsible"
    >
      {{ title }}
      <div class="faq-unit__icon-wrapper">
        <span class="faq-unit__icon iconfont ifaq"></span>
      </div>
    </div>
    <transition name="faq">
      <div v-show="!collapsed" class="faq-unit__text-box">
        <p class="faq-unit__text">
          <slot></slot>
        </p>
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

defineProps<{
  title: string
}>()

const collapsed = ref(true)

function toggleCollapsible(): void {
  collapsed.value = !collapsed.value
}
</script>
